<div>
    <app-fullscreen-close-button (onClosed)="onClosed()"></app-fullscreen-close-button>
    <div class="component-outlet">
        <ng-container *ngComponentOutlet="dynamicComponent.component | async; injector: injector"></ng-container>
    </div>
</div>

